export default "__VITE_ASSET__qrQGTwXM__"